module.exports = __webpack_public_path__ + "static/media/ingreso_icono.78ab2de4.svg";